import type { HotelI18n_HotelInfoSettingsPageQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useCreateHotelInfoI18nFormModel } from "../use-create-form-model";

type Props = {
	lang: LangCode;
	data: HotelI18n_HotelInfoSettingsPageQuery;
};

export const useInitialized = ({ lang, data }: Props) => {
	return {
		...useCreateHotelInfoI18nFormModel({ serverModel: data, lang }),
	};
};
